module.exports = __webpack_public_path__ + "img/Woveon6.c76a516a.jpg";